import React from 'react';

export default class Shot extends React.Component {

    updateValue = (event, fieldName) => {
        this.props.updateEventData(this.props.index, fieldName, event.target.value);
    }

    render() {
        return (
            <div className="event-col">
                <label>Result</label>
                <select name="result" className="form-control" value={this.props.event.value} onChange={(e) => this.updateValue(e, 'value')}>
                    <option value='shot'>Shot</option>
                    <option value='rebound_in_play'>Rebound in play</option>
                    <option value='deflect_in_play'>Deflect in play</option>
                    <option value='deflect_out_of_play'>Deflect out of play</option>
                    <option value='puck_frozen'>Puck frozen</option>
                    <option value='penalty_shot'>Penalty shot</option>
                </select>
            </div>
        );
    }
}
